
const devices = {
	mobile: 'max-width: 480px',
	minTablet: 'min-width: 481px',
	maxTablet: 'max-width: 1024px',
	minLaptop: 'min-width: 1025px',
	maxLaptop: 'max-width: 1440px',
	minFullHD: 'min-width: 1441px',
	maxFullHD: 'max-width: 1920px',
	min2k: 'min-width: 1921px',
	max2k: 'max-width: 2560px',
	min4k: 'min-width: 2561px',
	max4k: 'max-width: 4096px',
	iOS: '-webkit-touch-callout',
	iPhone: '-webkit-min-device-pixel-ratio: 2',
	macOS: '-webkit-min-device-pixel-ratio:0',
};

export default devices;
